import React, { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import InputGroup from "./InputGroup";
import PlaceholderGroup from "./PlaceholderGroup";
import CheckboxGroup from "./CheckboxGroup";
import RadioButtonGroup from "./RadioBtnGroup";
import SubmitButtonGroup from "./SubmitButtonGroup";
import FieldLabelGroup from "./FieldLabelGroup";
import SelectGroup from "./SelectGroup";
import TextAreaGroup from "./TextAreaGroup";
import BrandSelectGroup from "./BrandSelectGroup";
import ErrorTextGroup from "./ErrorTextGroup";
import ToggleGroup from "./ToggleGroup";


const FieldGroupsAccordion = () => {
  const [expanded, setExpanded] = useState(false); // State to track the expanded accordion

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const accordionStyle = {
    borderRadius: "15px", // Example for border-radius
    borderTopLeftRadius: "15px",
    borderTopRightRadius: "15px",
    marginTop: "10px",

    boxShadow: "none", // Remove box-shadow if needed

    "&:not(:last-child)": {
      borderBottom: 0, // Remove border from all but last item
    },
    "&:before": {
      display: "none", // Hide the default accordion expansion line
    },
    "&.Mui-expanded": {
      margin: "auto", // Avoid the default expanded margin
      marginTop: "20px",
      boxShadow: "0px 0px 10px 10px rgba(156, 156, 156, 0.1)", // Remove box-shadow if needed
    },
  };

  const accordionSummaryStyle = {
    boxShadow: "0px 0px 10px 10px rgba(156, 156, 156, 0.1)", // Remove box-shadow if needed
    borderTopLeftRadius: "15px",
    borderTopRightRadius: "15px",
    borderBottomLeftRadius: "15px",
    borderBottomRightRadius: "15px",
    backgroundColor: "#fff", // Default background for all summaries
    color: "#1dafec",

    "&.Mui-expanded": {
      backgroundColor: "#1dafec", // Background color when expanded/active
      color: "#fff",
      fontWeight: 500,
      letterSpacing: "1px",
      borderTopLeftRadius: "15px",
      borderTopRightRadius: "15px",
      borderBottomLeftRadius: "0px",
      borderBottomRightRadius: "0px",
    },
  };
  return (
    <div>

<Accordion
        expanded={expanded === "panel10"}
        onChange={handleChange("panel10")}
        sx={accordionStyle}
      >
        <AccordionSummary sx={accordionSummaryStyle}>
          Select Brand
        </AccordionSummary>
        <AccordionDetails>
          <BrandSelectGroup />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel0"}
        onChange={handleChange("panel0")}
        sx={accordionStyle}
      >
        <AccordionSummary sx={accordionSummaryStyle}>
          Form Layout
        </AccordionSummary>
        <AccordionDetails>
          <div>
            <p>In order to build a multi-column form, You'll need to apply the column classes in your Pardot form builder.
              <br />
              <b>form-col-1</b> for left columns fields, and <b>form-col-2</b> for the right columns fields.
              <br />
              Use <b>form-col-full</b> for columns fields that you wish to stay full width.</p>

          </div>
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        sx={accordionStyle}
      >
        <AccordionSummary sx={accordionSummaryStyle}>
          Input Styling
        </AccordionSummary>
        <AccordionDetails>
          <InputGroup />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
        sx={accordionStyle}
      >
        <AccordionSummary sx={accordionSummaryStyle}>
          Label Styling
        </AccordionSummary>
        <AccordionDetails>
          <FieldLabelGroup />
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
        sx={accordionStyle}
      >
        <AccordionSummary sx={accordionSummaryStyle}>
          Placeholder Styling
        </AccordionSummary>
        <AccordionDetails>
          <PlaceholderGroup />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
        sx={accordionStyle}
      >
        <AccordionSummary sx={accordionSummaryStyle}>
          DropDown Field Styling
        </AccordionSummary>
        <AccordionDetails>
          <SelectGroup />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel5"}
        onChange={handleChange("panel5")}
        sx={accordionStyle}
      >
        <AccordionSummary sx={accordionSummaryStyle}>
          TextArea Field Styling
        </AccordionSummary>
        <AccordionDetails>
          <TextAreaGroup />
        </AccordionDetails>
      </Accordion>
      
      <Accordion
        expanded={expanded === "panel6"}
        onChange={handleChange("panel6")}
        sx={accordionStyle}
      >
        <AccordionSummary sx={accordionSummaryStyle}>
          Checkbox Styling
        </AccordionSummary>
        <AccordionDetails>
          <CheckboxGroup />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel7"}
        onChange={handleChange("panel7")}
        sx={accordionStyle}
      >
        <AccordionSummary sx={accordionSummaryStyle}>
          Radio Button Styling
        </AccordionSummary>
        <AccordionDetails>
          <RadioButtonGroup />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel8"}
        onChange={handleChange("panel8")}
        sx={accordionStyle}
      >
        <AccordionSummary sx={accordionSummaryStyle}>
          Toggle Button Styling
        </AccordionSummary>
        <AccordionDetails>
          <ToggleGroup />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel9"}
        onChange={handleChange("panel9")}
        sx={accordionStyle}
      >
        <AccordionSummary sx={accordionSummaryStyle}>
          Submit Button Styling
        </AccordionSummary>
        <AccordionDetails>
          <SubmitButtonGroup />
        </AccordionDetails>
      </Accordion>
      
      <Accordion
        expanded={expanded === "panel10"}
        onChange={handleChange("panel10")}
        sx={accordionStyle}
      >
        <AccordionSummary sx={accordionSummaryStyle}>
          Error Styling
        </AccordionSummary>
        <AccordionDetails>
          <ErrorTextGroup />
        </AccordionDetails>
      </Accordion>

      {/* Repeat the pattern above for other field groups */}
    </div>
  );
};

export default FieldGroupsAccordion;
